<!--
  生日控件
  @props
    item
    form
  @emit
 -->
<template>
  <div class="calendar">
    <el-col :span="6">
      <el-form-item>
        <el-select v-model="year" class="inline-input" @change="dateChange" placeholder="请选择年份">
          <el-option v-for="y in yearList" :key="y" :value="y" :label="y + '年'">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="6">
      <el-form-item>
        <el-select v-model="month" class="inline-input" @change="dateChange" placeholder="请选择月份">
          <el-option v-for="m in 12" :key="m" :value="m" :label="m + '月'">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="6">
      <el-form-item>
        <!-- 公历 -->
        <el-select v-if="isLunar" v-model="date" class="inline-input" @change="dateChange" placeholder="请选择日期">
          <el-option v-for="d in lunarDays" :key="d" :value="d" :label="d + '日'">
          </el-option>
        </el-select>
        <!-- 农历 -->
        <el-select v-else v-model="date" class="inline-input" @change="dateChange" placeholder="请选择日期">
          <el-option v-for="d in days" :key="d" :value="d" :label="d + '日'">
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>

    <el-col :span="6">
      <el-form-item>
        <!-- 开关 -->
        <el-radio-group v-model="isLunar" size="small" @change="dateChange">
          <el-radio-button :label="0">公历</el-radio-button>
          <el-radio-button :label="1">农历</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-col>

  </div>
</template>

<script>
import Calendar from 'assets/js/calendar'

let yearList = []
let currentYear = (new Date()).getFullYear()
for (let i = 1910; i <= currentYear; i++) {
  yearList.push(i)
}

export default {
  props: {
    item: {
      type: Object
    },
    form: {
      type: Object,
      requred: true
    }
  },
  created () {
    let value = this.item.attrValue || this.form[this.item.attr] // 获得编辑时的初始值

    // 确定值不为空
    if (value && (value.birthday || value.lunarBirthday)) {

      // 农历模式
      if (value.isLunarBirthdayShown) {
        this.year = Number(value.lunarBirthday.slice(0, 4))
        this.month = Number(value.lunarBirthday.slice(5, 7))
        this.date = Number(value.lunarBirthday.slice(-2))
      } else {

        // 公历模式
        let d = new Date(value.birthday * 1000)
        this.year = d.getFullYear()
        this.month = d.getMonth() + 1
        this.date = d.getDate()
      }
      this.isLunar = value.isLunarBirthdayShown
    }
  },
  data () {
    return {
      yearList: yearList,
      year: 1980,
      month: '',
      date: '',
      isLunar: 0 // 是否开启农历
    }
  },
  computed: {

    // 公历每月天数
    days () {
      return Calendar.days(this.year, this.month)
    },

    // 农历每月天数
    lunarDays () {
      return Calendar.lunarDays(this.year, this.month)
    },

    // 是否开启验证
    isRequired () {
      return this.item.required
    }

  },
  methods: {

    // 日期变化
    dateChange () {
      // 当年月日均有值时，才继续向下执行

      if (this.year && this.month && this.date) {
        let data = {
          isLunarBirthdayShown: this.isLunar
        }
        let formatDate = ''
        let month = (`0${this.month}`).slice(-2)
        let date = (`0${this.date}`).slice(-2)
        formatDate = `${this.year}-${month}-${date}`

        // 公历需格式化为int值
        if (!this.isLunar) {
          let d = new Date(this.year, month - 1, date)
          formatDate = d.getTime() / 1000
          data.birthday = formatDate
        } else {
          data.lunarBirthday = formatDate
        }

        this.$set(this.form, this.item.attr, data)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .calendar {
    width: 105%;
    .inline-input {
      display: inline-block;
      margin: 0 12px 0 0;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// date-birthday.vue?d40ed548